// PaginationButtons.tsx
import { Box } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface Props {
  count: number;
  page: number;
  onChange: (value: number) => void;
  totalItems?: number;
  itemsPerPage?: number;
}

export default function PaginationButtons({ count, page, onChange, totalItems, itemsPerPage }: Props) {
  const startItem = (page - 1) * itemsPerPage + 1;
  const endItem = Math.min(page * itemsPerPage, totalItems);

  return (
    <Box display="flex" gap={2} alignItems="center" >
      {itemsPerPage && totalItems && <Typography variant="body2">
        {`${startItem||0}–${endItem||0} of ${totalItems||0}`}
      </Typography>}

      <Stack spacing={1} alignItems="center">
        <Pagination
          count={count}
          page={page}
          color="primary"
          onChange={(e, value) => onChange(value)}
          showFirstButton
          showLastButton
          variant="outlined"
          shape="rounded"
          sx={{
            "& .MuiPaginationItem-root": {
              "&:hover": {
                backgroundColor: "##f5f8f8",
                borderColor:"##f5f8f8",
                color:"#000"
              }
            }
          }}
        />
      </Stack>
    </Box>
  );
}
